import { Route, Routes } from 'react-router'
import { TollFreeStepsRouter } from 'pages/settings/pages/compliance/pages/tollFree/route/tollFreeStepsRouter'
import { TollFreeRoutes } from 'pages/settings/pages/compliance/pages/tollFree/route/type'
import { UseCaseDetails } from 'pages/settings/pages/compliance/pages/tollFree/pages/UseCaseDetails/ui/UseCaseDetails'
import { TollFreeProviderLayout } from 'pages/settings/pages/compliance/pages/tollFree/layout/TollFreeProviderLayout'
import { AddNumberRouter } from './addNumberRouter'

export const TollFreeRootRouter = () => {
  return (
    <Routes>
      <Route element={<TollFreeProviderLayout />}>
        <Route path={`/${TollFreeRoutes.view}/:profile_id`} element={<UseCaseDetails />} />
        <Route
          path={`/${TollFreeRoutes.view}/:profile_id/${TollFreeRoutes.steps}/*`}
          element={<TollFreeStepsRouter />}
        />
        <Route
          path={`/${TollFreeRoutes.view}/:profile_id/use-case-number/:useCaseNumber/${TollFreeRoutes.steps}/*`}
          element={<TollFreeStepsRouter />}
        />
        <Route path={`/${TollFreeRoutes.addNumber}/*`} element={<AddNumberRouter />} />
        <Route path={`/${TollFreeRoutes.steps}/*`} element={<TollFreeStepsRouter />} />
      </Route>
    </Routes>
  )
}
